module.exports = __webpack_public_path__ + "source-sans-pro-v13-latin-regular.woff?5cc3aae674ea3b199313b3b83bd795bc";